'use strict';
var CsaPanelController = /** @class */ (function () {
    /*@ngInject*/
    function CsaPanelController(CsaPanelService, UserService) {
        this.requireTLAssist = false;
        this.UserService = UserService;
        this.orderOriginOptions = CsaPanelService.getOrderOriginOptions();
        this.holdCodes = CsaPanelService.getHoldCodes();
        this.orderComments = CsaPanelService.getOrderComments();
    }
    CsaPanelController.prototype.$onInit = function () {
        var _this = this;
        this.UserService.get().then(function (user) {
            if (user.data.response) {
                _this.userInfo = user.data.response;
            }
        })
            .catch(function (err) {
            console.log("csaPanel get user error => " + err);
        });
    };
    CsaPanelController.prototype.changeOrderComment = function () {
        this.editedOrderComment = this.selectedOrderComment;
    };
    return CsaPanelController;
}());
export default CsaPanelController;
//# sourceMappingURL=csa-panel.controller.js.map